import React, { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import Summary from "./partials/Summary";
import { getList, getListBoats, getListRoutes, update } from "./controller";
import CancelPopup from "./partials/popups/CancelPopup";
import ConfirmPopup from "./partials/popups/ConfirmPopup";
import UpdatePopup from "./partials/popups/UpdatePopup";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    method: 'BY_ID', // 'BY_CONDITION', BY_CART_ID
    from: new Date(),
    to: new Date(),
    identify: '',
    routeId: '',
    status: '',
    cartId: '',
    id: '',
    page: 0
  },
  filterCondition: {
    listRoute: [],
    listBoat: [],
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  confirmPopup: {
    show: false,
    image: '',
    id: undefined,
    confirmed: false,
  },
  cancelPopup: {
    show: false,
    id: undefined,
    confirmed: false,
  },
  updatePopup: {
    show: false,
    id: undefined,
    departDate: undefined,
    departTime: undefined,
    routeName: undefined,
    boatName: undefined,
    seatName: undefined,
    price: undefined,
    image: undefined,
    add: 0,
    sub: 0,
    confirmed: false,
  },
  filterPressCount: 0,
  exportPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          method: state.filter.method,
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'CHANGE_FILTER_METHOD':
      return {
        ...state,
        filter: {
          from: new Date(),
          to: new Date(),
          identify: '',
          routeId: '',
          status: '',
          cartId: action.payload.cartId || '',
          id: '',
          page: 0,
          method: action.payload.method
        },
        data: {
          list: [],
          total: 0,
          totalPage: 0
        },
        filterPressCount: 0,
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'OPEN_CANCEL_POPUP':
      return {
        ...state,
        cancelPopup: {
          show: true,
          confirmed: false,
          id: action.payload.id,
        }
      }
    case 'CLOSE_CANCEL_POPUP':
      return {
        ...state,
        cancelPopup: {
          show: false,
          id: action.payload ? state.cancelPopup.id : undefined,
          confirmed: action.payload
        }
      }
    case 'OPEN_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: true,
          confirmed: false,
          id: action.payload.id,
        }
      }
    case 'CLOSE_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: false,
          image: action.payload.confirmed ? action.payload.image : '',
          id: action.payload.confirmed ? state.confirmPopup.id : undefined,
          confirmed: action.payload.confirmed
        }
      }
    case 'OPEN_UPDATE_POPUP':
      return {
        ...state,
        updatePopup: {
          show: true,
          id: action.payload.id,
          departDate: action.payload.departDate,
          departTime: action.payload.departTime,
          seatName: action.payload.seatName,
          routeName: action.payload.routeName,
          boatName: action.payload.boatName,
          price: action.payload.price,
          image: action.payload.image,
          add: 0,
          sub: 0,
          confirmed: false,
        }
      }
    case 'CLOSE_UPDATE_POPUP':
      return {
        ...state,
        updatePopup: {
          show: false,
          id: action.payload.confirmed ? state.updatePopup.id : undefined,
          confirmed: action.payload.confirmed,
          departDate: action.payload.confirmed ? action.payload.departDate : undefined,
          departTime: action.payload.confirmed ? action.payload.departTime : undefined,
          seatName: action.payload.confirmed ? action.payload.seatName : undefined,
          routeName: action.payload.confirmed ? action.payload.routeName : undefined,
          boatName: action.payload.confirmed ? action.payload.boatName : undefined,
          price: action.payload.confirmed ? action.payload.price : undefined,
          image: action.payload.confirmed ? action.payload.image : undefined,
          add: action.payload.confirmed ? action.payload.price - state.updatePopup.price > 0 ? action.payload.price - state.updatePopup.price : 0 : 0,
          sub: action.payload.confirmed ? action.payload.price - state.updatePopup.price < 0 ? state.updatePopup.price - action.payload.price : 0 : 0,
        }
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_FILTER_CONDITION':
      return {
        ...state,
        filterCondition: {
          listRoute: action.payload.routes,
          listBoat: action.payload.boats,
        },
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['wvivu'])

  let searchParams = useLocation();

  const baseCartId = new URLSearchParams(searchParams.search).get('cartId');

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const filterPressCount = useRef(state.filterPressCount)

  const getAllFunc = useCallback(async () => {
    setLoading(true)
    const filterObj = state.filter.method === 'BY_CONDITION' ? {
      from: state.filter.from,
      to: state.filter.to,
      identify: state.filter.identify,
      routeId: state.filter.routeId,
      status: state.filter.status,
    } : state.filter.method === 'BY_ID' ? {
      id: state.filter.id,
    } : {
      cartId: state.filter.cartId,
    }
    const response = await getList(cookies.wvivu, filterObj, state.filter.page)

    if (response) {
      setError(false)
      dispatch({
        type: 'UPDATE_DATA',
        payload: response
      })
    } else {
      setError(true)
    }
    setLoading(false)
  }, [
    cookies.wvivu,
    state.filter.from,
    state.filter.to,
    state.filter.page,
    state.filter.identify,
    state.filter.routeId,
    state.filter.status,
    state.filter.method,
    state.filter.id,
    state.filter.cartId,
  ])

  const getFilterConditionFunc = useCallback(async () => {
    setLoading(true)
    const response = await Promise.all([
      getListRoutes(cookies.wvivu),
      getListBoats(cookies.wvivu),
    ])

    if (response) {
      setError(false)
      dispatch({
        type: 'UPDATE_FILTER_CONDITION',
        payload: {
          routes: response[0],
          boats: response[1],
        }
      })
    } else {
      setError(true)
    }
    setLoading(false)
  }, [cookies.wvivu])

  useEffect(() => {
    if (state.filterPressCount > 0 && filterPressCount.current < state.filterPressCount) {
      getAllFunc()
    }
    filterPressCount.current = state.filterPressCount
  }, [getAllFunc, state.filterPressCount])

  useEffect(() => {
    document.title = "Vé tàu"
    getFilterConditionFunc()
    if (baseCartId) {
      dispatch({
        type: 'CHANGE_FILTER_METHOD',
        payload: {
          method: 'BY_CART_ID',
          cartId: baseCartId
        }
      })
    }
  }, [getFilterConditionFunc, baseCartId]);

  const cancelTicketFunc = useCallback(async (id) => {
    const response = await update(cookies.wvivu, id, 'CANCEL', undefined)

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [cookies.wvivu, getAllFunc])

  useEffect(() => {
    if (state.cancelPopup.confirmed && state.cancelPopup.id) {
      cancelTicketFunc(state.cancelPopup.id)
    }
  }, [cancelTicketFunc, state.cancelPopup.confirmed, state.cancelPopup.id])

  const confirmTicketFunc = useCallback(async (id, image) => {
    const response = await update(cookies.wvivu, id, 'CONFIRM', {
      image: image,
    })

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [cookies.wvivu, getAllFunc])

  const updateTicketFunc = useCallback(async (id) => {
    const routeId = state.filterCondition.listRoute.filter(it => it.name === state.updatePopup.routeName)[0].id
    const boatId = state.filterCondition.listBoat.filter(it => it.name === state.updatePopup.boatName)[0].id
    const response = await update(cookies.wvivu, id, 'CONFIRM_UPDATED', {
      image: state.updatePopup.image,
      departDate: state.updatePopup.departDate,
      departTime: state.updatePopup.departTime + ':00',
      routeId: routeId,
      boatId: boatId,
      seatName: state.updatePopup.seatName,
      add: state.updatePopup.add,
      sub: state.updatePopup.sub,
    })

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    getAllFunc,
    state.filterCondition.listRoute,
    state.filterCondition.listBoat,
    state.updatePopup.image,
    state.updatePopup.departDate,
    state.updatePopup.departTime,
    state.updatePopup.routeName,
    state.updatePopup.boatName,
    state.updatePopup.seatName,
    state.updatePopup.add,
    state.updatePopup.sub,
  ])

  useEffect(() => {
    if (state.confirmPopup.confirmed && state.confirmPopup.id && state.confirmPopup.image) {
      confirmTicketFunc(state.confirmPopup.id, state.confirmPopup.image)
    }
  }, [confirmTicketFunc, state.confirmPopup.confirmed, state.confirmPopup.id])

  useEffect(() => {
    if (state.updatePopup.confirmed && state.updatePopup.id) {
      updateTicketFunc(state.updatePopup.id)
    }
  }, [updateTicketFunc, state.updatePopup.confirmed, state.updatePopup.id])

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Summary />

      <br />

      {loading ? 'Loading.....' : error ? 'Lỗi!?' : <Table />}

      <UpdatePopup />
      <CancelPopup />
      <ConfirmPopup />
    </Context.Provider>
  );
};
